module.exports = __webpack_public_path__ + "static/media/hr-HR.b5500325.md";